import { Place } from 'kiolyn-api';
import { loadScript } from './ScriptUtils';

export interface PlaceType {
  description: string;
  place_id: string;
  structured_formatting?: {
    main_text: string;
    secondary_text: string;
    main_text_matched_substrings: [
      {
        offset: number;
        length: number;
      }
    ];
  };
}

export interface DirectionType {
  routes?: RouteType[];
}

export interface RouteType {
  legs: RouteLegType[];
}

export interface RouteLegType {
  distance: { value: number };
}

export function loadGoogleMapScript() {
  if (
    typeof window !== 'undefined' &&
    !document.querySelector('#google-maps')
  ) {
    loadScript(
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyBNBkPUw64sAkVmlIsmWwMVryGeJSng0D0&libraries=places',
      // 'https://maps.googleapis.com/maps/api/js?key=AIzaSyC5Bx4-zQRhDE86Qh8qitcTIOOr60Uu6Ic&libraries=places',
      document.querySelector('head'),
      'google-maps'
    );
  }
}

let geocoder: any;
export function getComponentAddressByPlace(
  place?: Place
): Promise<Place | undefined> {
  return new Promise(resolve => {
    const placeId = place?.place_id;
    if (!placeId) return resolve(undefined);
    // Update zip code by billing place
    if (!geocoder && (window as any).google) {
      geocoder = new (window as any).google.maps.Geocoder();
    }

    return geocoder.geocode({ placeId }, (results: any[]) => {
      if (results !== null && results.length > 0) {
        const getPart = (name: string): string => {
          return results[0]?.address_components.find((e: any) =>
            e.types.includes(name)
          )?.long_name;
        };

        const city = getPart('administrative_area_level_2');
        const state = getPart('administrative_area_level_1');
        const subpremise = getPart('subpremise') ?? '';
        const street = `${getPart('street_number') ?? ''} ${getPart('route') ??
          ''} ${subpremise ? `#${subpremise}` : ''}`.trim();
        const postalCode = getPart('postal_code');

        return resolve({
          city,
          state,
          street,
          zip_code: postalCode,
          place_id: place?.place_id,
          description: place?.description
        });
      }

      return resolve(undefined);
    });
  });
}
